import { render, staticRenderFns } from "./StaffPaymentsView.vue?vue&type=template&id=170af96a&scoped=true"
import script from "./StaffPaymentsView.vue?vue&type=script&lang=js"
export * from "./StaffPaymentsView.vue?vue&type=script&lang=js"
import style0 from "./StaffPaymentsView.vue?vue&type=style&index=0&id=170af96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170af96a",
  null
  
)

export default component.exports